import React, { useCallback } from 'react';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { useUniqueId } from '@wix/da-a11y/pkg/hooks/useUniqueId';
import { getDeviationResourceType } from '../../_helpers';
import PopperDropdownManager from '../../../Dropdown/PopperDropdownLayout/PopperDropdownManager';
import PopperDropdownToggle from '../../../Dropdown/PopperDropdownLayout/PopperDropdownToggle';
import StandardDropdownMenu from '../../../Dropdown/Preset/StandardDropdown/StandardDropdownMenu';
import { useDropdownItems } from '../../../Dropdown/hooks/useDropdownItems';
import { ThemeOverride, ThemeOptions, } from '@wix/da-react-context/pkg/ThemeContext';
import ButtonB5 from '../../../Button/ButtonB5';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import EllipsisIcon from '@wix/da-ds/pkg/Icons/Ellipsis';
import s from './ThumbActions.scss';
var ThumbActions = function (_a) {
    var deviation = _a.deviation, actions = _a.actions, className = _a.className, _b = _a.withBackground, withBackground = _b === void 0 ? true : _b, _c = _a.forceDarkTheme, forceDarkTheme = _c === void 0 ? true : _c;
    var dropdownId = useUniqueId();
    var logger = useBiLogger();
    var filteredItems = useDropdownItems(actions).filteredItems;
    var typeid = getDeviationResourceType(deviation);
    var onOpen = useCallback(function () {
        logger({
            evid: BiEventType.MORE_MENU_CLICK,
            typeid: typeid,
            itemid: deviation.deviationId,
        });
    }, [logger, typeid, deviation.deviationId]);
    var button = (React.createElement(ButtonB5, { icon: EllipsisIcon, className: s['toggle'], iconProps: {
            size: IconSize.SMALL,
        }, withBackground: withBackground }));
    return (React.createElement(PopperDropdownManager, { onOpen: onOpen },
        React.createElement(PopperDropdownToggle, { className: className, "aria-owns": dropdownId }, forceDarkTheme ? (React.createElement(ThemeOverride, { theme: ThemeOptions.DARK }, button)) : (button)),
        React.createElement(StandardDropdownMenu, { id: dropdownId, items: filteredItems, role: "menu", className: s['menu'] })));
};
ThumbActions.displayName = 'ThumbActions';
export default ThumbActions;
//# sourceMappingURL=ThumbActions.js.map